.errorPage {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: "Montserrat", sans-serif;

  .errorHeader,
  .errorFooter {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .errorHeader {
    border-bottom: 1px solid #eeeeee;

    img {
      width: 71.55px;
      height: 24px;
    }
  }

  .errorPageWrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    .erroricon {
      width: 240px;
      height: 200px;
      margin: 16px;
    }

    .errorTextWrapper {
      max-width: 491px;
      width: fit-content;
      margin: 0 20px;

      .errorTextCode {
        color: #818188;
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
      }

      .errorTextTitle {
        color: #0e3aa8;
        font-size: 40px;
        line-height: 48px;
        font-weight: 600;
      }

      .errorTextDescription {
        font-size: 14px;
        line-height: 21px;
        color: #1a1a23;

        .errorRedirectLink {
          font-weight: 700;
          color: #0e3aa8;
          text-decoration: none;
        }
      }
    }
  }

  .errorFooter {
    color: #818188;
    font-size: 8px;
    font-weight: 400;
    border-top: 1px solid #eeeeee;
  }
}

@media screen and (max-width: 768px) {
  .errorPage .errorPageWrapper {
    flex-wrap: wrap;

    .errorTextWrapper {
      .errorTextCode,
      .errorTextTitle,
      .errorTextDescription {
        text-align: center;
      }

      .errorTextTitle {
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 16px;
      }
    }
  }
}
